import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import InspectionHomePage from "../InspectionHome/InspectionHome";
import CreateDrainfieldInstallationPage from "./SupportRequestForm";
//import EditDrainfieldInstallationPage from "./EditDrainfieldInstallationInspectionForm";
import HomePage from "../Home/Home";
import SupportRequestPage from "./SupportRequestForm";


export const SupportRequestModule = () => {
  let { path } = useRouteMatch();

  return (
    
      <Switch>
          <ProtectedRoute exact path={path}>
              <SupportRequestPage />
          </ProtectedRoute>
         
             
        <Route>
          <NotFound />
        </Route>
      </Switch>
    
  );
};

export default SupportRequestModule;
